import { useEffect, useState } from 'react';
import { listProposals } from '../../services/agent';
import type { ProposalListItem } from '../../types/agent';
import { ProposalCard } from './ProposalCard';
import { Header, DashboardLayout } from '@/components/shared';
import { useTheme } from '@/contexts/ThemeContext';

type Tab = 'pending' | 'approved' | 'rejected' | 'expired';

export default function AgentInboxPage() {
  const [tab, setTab] = useState<Tab>('pending');
  const [items, setItems] = useState<ProposalListItem[]>([]);
  const [loading, setLoading] = useState(true);
  const { isDark } = useTheme();
  const userInfoStr = localStorage.getItem('user_info');
  const userInfo = userInfoStr ? JSON.parse(userInfoStr) : null;

  useEffect(() => {
    setLoading(true);
    listProposals(tab)
      .then(({ results }) => setItems(results))
      .finally(() => setLoading(false));
  }, [tab]);

  return (
    <div className="min-h-screen cgm-bg-primary">
      <Header userInfo={userInfo} />
      <DashboardLayout>
        <h1 className="text-2xl font-semibold mb-4">Agent Inbox</h1>
        <div className="flex gap-1 mb-4" data-tour="agent-tabs">
          {(['pending', 'approved', 'rejected', 'expired'] as Tab[]).map(t => (
            <button
              key={t}
              onClick={() => setTab(t)}
              className={`px-3 py-1 text-sm ${
                tab === t
                  ? 'bg-neutral-900 text-white dark:bg-neutral-100 dark:text-neutral-900'
                  : 'bg-neutral-100 text-neutral-700 dark:bg-neutral-800 dark:text-neutral-300'
              }`}
            >
              {t}
            </button>
          ))}
        </div>
        {loading && <div>Loading...</div>}
        <div className="space-y-2 min-h-[3rem]" data-tour="agent-proposal-list">
          {!loading && items.length === 0 && (
            <div className="text-sm text-neutral-500 dark:text-neutral-400">No proposals in this bucket.</div>
          )}
          {items.map(p => <ProposalCard key={p.id} p={p} />)}
        </div>
      </DashboardLayout>
    </div>
  );
}
